import React from 'react';
import { SmallIconButton } from 'library';
import { Grid } from '@material-ui/core';
import ChatBubbleOutlineOutlinedIcon from '@material-ui/icons/ChatBubbleOutlineOutlined';

interface IProps {
    chatAction: () => void;
}

export default function ActionSection({ chatAction }: IProps) {
    return (
        <Grid container item justify="flex-end" spacing={2}>
            <Grid item>
                <SmallIconButton onClick={chatAction} icon={ChatBubbleOutlineOutlinedIcon} />
            </Grid>
        </Grid>
    );
}
